export default __webpack_public_path__ + "static/media/gowardhan.459c2ab7.png";